import { type CompositeSettings } from "@client/types";
import * as React from "react";

export const getBorder = (setting: CompositeSettings.Border | null | undefined): React.CSSProperties | undefined => {
  if (!setting) return { border: "none" };

  return {
    borderColor: setting.color ?? "var(--color)",
    borderStyle: setting.style,
    borderRadius: setting.radius,
    borderWidth: setting.width
  };
};
